// styles
import styles from '../styles/Button.module.css';
import { CubeIcon } from '../theme/customIcons';

export type PRIMARY = 'primary';
export type SECONDARY = 'secondary';

interface ButtonProps {
  text: string | JSX.Element;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  id?: string;
  href?: string;
  isLoading?: boolean;
  variant: PRIMARY | SECONDARY;
}

const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  disabled,
  id,
  href,
  isLoading,
  variant = 'primary'
}) => {
  const completedClass = isLoading ? styles.buttonLoading : '';

  return href ? (
    <a
        className={`${styles.button} ${variant === 'primary' ? styles.primary : ''} ${completedClass}`}
        target="_blank"
        rel="noreferrer"
        href={href}
        id={id}
    >
      <div style={{display: 'flex', justifyContent: 'center', gap: 8}}>
        <p style={{lineHeight: '25px'}}>
          {text}
        </p>
        {variant === 'primary' && <CubeIcon />}
      </div>
    </a>
  ) : (
    <button
      className={`${styles.button} ${variant === 'primary' ? styles.primary : styles.secondary} ${completedClass}`}
      onClick={(e) => {
        onClick && onClick(e);
      }}
      disabled={disabled}
      id={id}
    >
      <div style={{display: 'flex', justifyContent: 'center', gap: 8}}>
        <p style={{lineHeight: '25px'}}>
          {text}
        </p>
        {variant === 'primary' && <CubeIcon />}
      </div>
    </button>
  )
};

export default Button;
